import { Box, Typography, Button } from "@mui/material";
import { DownloadSimpleIcon, Plus, PlusIcon } from "@phosphor-icons/react";
import { StyledInvoices } from "./invoices.styled";
import { useContext, useEffect, useMemo, useState } from "react";
import { LanguageContext } from "../../globals/LanguageContext";
import { DarkOverlay } from "../../components/darkOverlay/DarkOverlay";
import { AddInvoiceForm } from "../../components/form/AddInvoiceForm";
import { InvoiceList } from "../../components/invoiceList/invoiceList";
import { Invoice } from "../../models/Invoice";
import { useInvoice } from "../../stores/useInvoice";
import { useProfile } from "../../stores/useProfile";
import { redirect, useNavigate } from "react-router-dom";

export const Invoices = () => {
  const [darkOverlayOpened, setDarkOverlayOpened] = useState<boolean>(false);
  const [loadedInvoices, setLoadedInvoices] = useState<Invoice[]>([]);
  const [filteredInvoices, setFilteredInvoices] = useState<Invoice[]>([]);
  const { dictionary } = useContext(LanguageContext);
  const { invoices, fetchInvoices, downloadInvoices } = useInvoice();
  const { user } = useProfile();
  const [selectedInvoice, setSelectedInvoice] = useState<Invoice | undefined>(
    undefined
  );
  const redirect = useNavigate();

  useEffect(() => {
    if (!invoices) return;

    setLoadedInvoices(invoices);
  }, [invoices]);

  const updateItems = async () => {
    if (!user) return;

    await fetchInvoices(user);
  };

  const onSuccess = () => {
    updateItems();
    setDarkOverlayOpened(false);
    setSelectedInvoice(undefined);
  };

  const onSelect = (invoice: Invoice) => {
    setSelectedInvoice(invoice);
    setDarkOverlayOpened(true);
  };

  const onFilter = (filteredInvoices: Invoice[]) => {
    setFilteredInvoices(filteredInvoices);
  };

const handleDownload = async () => {
  if (!user) return;
  const ids = filteredInvoices
    .filter(
      (invoice): invoice is Invoice & { id: number } =>
        !!invoice.name && typeof invoice.id === "number"
    )
    .map(invoice => invoice.id);

  if (!ids.length) return;

  await downloadInvoices(user, ids);
};

  return (
    <StyledInvoices>
      <DarkOverlay
        opened={darkOverlayOpened}
        component={
          <AddInvoiceForm onSuccess={onSuccess} invoice={selectedInvoice} />
        }
        onClose={() => {
          setDarkOverlayOpened(false);
        }}
      />
      <Box className="header">
        <Typography variant="h1">{dictionary.pages.invoices.title}</Typography>
        <Box className="buttonWrapper">
          <Button
            variant="outlined"
            className="addBtn"
            onClick={handleDownload}
          >
            <DownloadSimpleIcon size={32} weight="bold" />
            {dictionary.pages.invoices.buttons.export}
          </Button>
          <Button
            variant="outlined"
            className="addBtn"
            onClick={() => setDarkOverlayOpened(true)}
          >
            <PlusIcon size={32} weight="bold" />
            {dictionary.pages.invoices.buttons.add}
          </Button>
          <Button
            variant="outlined"
            className="createBtn"
            onClick={() => redirect('/invoice/create')}
          >
            <PlusIcon size={32} weight="bold" />
            {dictionary.pages.invoices.buttons.create}
          </Button>
        </Box>
      </Box>
      <InvoiceList
        invoices={loadedInvoices}
        fullScreen={true}
        onSelect={onSelect}
        onFilter={onFilter}
        onRemove={updateItems}
      />
    </StyledInvoices>
  );
};
